import { Skeleton } from "primereact/skeleton"

export function ProgramSubscriberDetailsContentSkeleton() {
  return <Skeleton width="100%" height="25rem" className="rounded-card" />
}
